import { pluralize } from '@travelata-libs/utils';
import { RESORT_PLURAL_FORMS } from '@/entities/resort';
import type { Selection } from '@/features/searchForm/destination';

export function destinationSummary(selection: Selection | null | undefined): string {
  if (!selection || selection.kind === 'none') {
    return '';
  }

  const country = selection.country.name;

  if (selection.kind === 'resorts') {
    if (selection.resorts.length === 1) {
      return `${country}, ${selection.resorts[0].name}`;
    }
    return `${country}, ${pluralize(RESORT_PLURAL_FORMS, selection.resorts.length)}`;
  }

  if (selection.kind === 'hotels') {
    if (selection.hotels.length === 0) {
      return country;
    }
    return `${country}, ${selection.hotels.map((hotel) => hotel.name).join(', ')}`;
  }

  return `${country}, Все курорты`;
}
